<form [formGroup]="form" [class.single-select-form]="bordered">
    <mat-form-field appearance="outline" class="always-outline" style="width: 100%;">
        <mat-select [disabled]="disabled" [ngClass]="{'disabled-option': disabled}" [placeholder]="placeholder" formControlName="item" [matTooltip]="disabled ? '' : selectedText">
            <mat-select-trigger class="select-trigger-text">
                <span *ngIf="selectedItemData?.useChip; else plainText">
                    <kt-chip
                        [label]="selectedItemData.label"
                        [backgroundColor]="selectedItemData.backgroundColor"
                        [labelColor]="selectedItemData.labelColor"
                        borderRadius='large'
                        height='small'>
                    </kt-chip>
                </span>
                <ng-template #plainText>
                    {{selectedText}}
                </ng-template>
            </mat-select-trigger>

            <mat-option *ngIf="searchable">
                <ngx-mat-select-search
                    [placeholderLabel]="searchPlaceholder"
                    [formControl]="searchFilter"
                    [noEntriesFoundLabel]="noEntriesFoundLabel">
                </ngx-mat-select-search>
            </mat-option>

            <ng-container *ngFor="let item of displayItems">
                <ng-container *ngIf="!item.hidden">
                    <mat-option class="select-boxes"  [value]="item" [disabled]="item.disabled" [ngClass]="{'disabled-option': item.disabled}">
                        <kt-chip *ngIf="item.useChip; else plainOption" [label]="item.label"
                            [backgroundColor]="item.backgroundColor" [labelColor]="item.labelColor" borderRadius='large'
                            height='small'>
                        </kt-chip>
                        <ng-template #plainOption>
                            {{item.label}}
                        </ng-template>
                    </mat-option>
                </ng-container>
            </ng-container>
        </mat-select>
    </mat-form-field>

    <span *ngIf="bordered" class="material-symbols-rounded arrow-down">
        keyboard_arrow_down
    </span>
</form>